import { render, staticRenderFns } from "./commodityWorkbench.vue?vue&type=template&id=e5e76bd4&"
import script from "./commodityWorkbench.vue?vue&type=script&lang=js&"
export * from "./commodityWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./commodityWorkbench.vue?vue&type=style&index=0&id=e5e76bd4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports